import styled from 'styled-components';

export const SlotSectionTitle = styled.div`
  font-weight: bold;
  font-size: 1rem;
  margin-top: 1.5rem;
  margin-bottom: 1rem;
`;

export const SlotRowContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 2rem;
  padding: 1.5rem;
  border: 0.0625rem solid ${({ theme }) => theme.color.gray[300]};
  border-radius: 0.25rem;
  background-color: ${({ theme }) => theme.color.gray[100]};
  width: 100%;
  box-sizing: border-box;
  margin-bottom: 1rem;
`;

export const SlotRowField = styled.div`
  display: flex;
  flex-direction: column;
`;

export const SlotRowLabel = styled.div`
  margin-bottom: 0.5rem;
  font-size: 0.875rem;
  font-weight: 600;
  color: ${({ theme }) => theme.color.gray[900]};
`;

export const SlotRowValue = styled.div`
  font-size: 0.875rem;
  color: ${({ theme }) => theme.color.gray[700]};
`;
